<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <form-admin-organisation :id="id"></form-admin-organisation>
        </b-card>
    </div>
</template>

<script>
    import FormAdminOrganisation from '~/components/forms/admin/organisation/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
        },
        components: {
            'form-admin-organisation': FormAdminOrganisation,
        },
    }
</script>

<style lang="css" scoped>
</style>